import { Component, OnInit, Input, Output, EventEmitter, OnChanges } from '@angular/core';

@Component({
  selector: 'bt-paginator',
  templateUrl: './paginator.component.html',
  styleUrls: ['./paginator.component.scss']
})
export class PaginatorComponent implements OnInit, OnChanges {
  @Input() pageNumber;

  @Output() pageSelected = new EventEmitter<number>();
  arrayPageNumber = [];
  currentPage = 1;

  constructor() { }

  ngOnInit() {
  }
  ngOnChanges() {
    if (this.pageNumber) {
      this.arrayPageNumber = new Array(this.pageNumber).fill(1);
    }
  }
  changeCurrentPage(i) {
    this.currentPage = i;
    this.pageSelected.emit(i);
  }
  firstPage() {
    this.currentPage = 1;
    this.pageSelected.emit(1);
  }
  lastPage() {
    this.currentPage = this.pageNumber;
    this.pageSelected.emit(this.pageNumber);
  }
  nextPage() {
    this.currentPage += 1;
    this.pageSelected.emit(this.currentPage + 1);
  }
  perviosPage() {
    this.currentPage -= 1;
    this.pageSelected.emit(this.currentPage - 1);

  }
}
